export { default } from './PageCities.vue'
